import React from 'react';
import clsx from 'clsx';

import { TabLabels } from '../const';
import { useFetch } from '../../../hooks';
import { useLocalize } from '../../../hooks';
import { getLastAttempt } from '../../../api';
import { QuizResult } from '../../../components';
import { MarkdownContainer, Button, Tabs, Tab } from '../../../components';

type QuizStepProps = {
  stepId: string;
  isMobile: boolean;

  enrollmentId: string;
  navigation?: React.ReactNode;

  isQuizFinished: boolean;
  startQuiz: () => void;
};

export const QuizStep: React.FC<QuizStepProps> = ({
  stepId,
  isMobile,
  navigation,
  enrollmentId,

  isQuizFinished,
  startQuiz,
}) => {
  const { t } = useLocalize();
  const { intializing: loading, data: result } = useFetch(
    () => getLastAttempt(enrollmentId, stepId),
    [enrollmentId, stepId]
  );

  const testContent = t('course.page.instructions');
  const tabs = [
    {
      name: 'quizResults',
      label: t('course.page.lastattempt'),
    },
  ];
  isMobile && tabs.push({ name: 'course', label: t(TabLabels.Course) });

  return (
    <div className={clsx('pb-lg', isMobile ? 'px-md' : '')}>
      <MarkdownContainer className="text-medium mb-sm">
        {testContent}
      </MarkdownContainer>
      {!isQuizFinished && (
        <div className="mb-xl">
          <Button
            label={t('course.page.startquiz')}
            onClick={startQuiz}
            className={clsx(
              'bg-main hover:bg-goToPracticeHover',
              isMobile ? 'w-full' : '',
              isQuizFinished
                ? 'border border-solid border-blackBorder bg-white text-blackBorder hover:bg-goToPracticeHover hover:text-white hover:border-transparent'
                : 'border-none'
            )}
            type="empty"
          />
        </div>
      )}
      {!!result && !loading && (
        <Tabs
          tabs={tabs}
          tabClassNameActive="text-main"
          className={isMobile ? 'px-md' : ''}
          tabClassNameNotActive="text-textSecondary"
          tabsClassName={clsx(
            'border-b-transparent',
            isMobile ? 'overflow-x-auto whitespace-nowrap' : ''
          )}
          tabClassName="border-main border-b-2 font-semibold py-0 px-0 cursor-pointer transition-def py-sm px-md text-medium font-medium border-solid"
        >
          <Tab name="quizResults">
            <QuizResult result={result} className="mt-lg" withReview />
          </Tab>
          {isMobile && <Tab name="course">{navigation}</Tab>}
        </Tabs>
      )}
    </div>
  );
};
